<template>
  <LayoutAuthPrimary>
    <div :style="style.container">
      <CardSecondary :style="getCardStyle">
        <div :style="getHeaderStyle">
          <HeaderLargePrimary>
            {{ headerTexts[context] }}
          </HeaderLargePrimary>
          <div
            v-if="!passwordReset"
            :style="style.subHeader"
          >
            <template v-if="signup">
              <TextRegular :isInline="true">
                Already using Zipteam?
              </TextRegular>
              <LinkPrimary
                :disabled="isRequesting"
                :isInline="true"
                :to="{ name: 'login' }"
              >
                Log in<!-- Avoid auto-added whitespace
           --></LinkPrimary><!--
           --><TextRegular :isInline="true"><!--
             -->.<!--
           --></TextRegular>
            </template>
            <template v-else-if="login">
              <TextRegular :isInline="true">
                New to Zipteam?
              </TextRegular>
              <LinkPrimary
                :isInline="true"
                :to="{ name: 'signup' }"
              >
                Sign up<!-- Avoid auto-added whitespace
           --></LinkPrimary><!--
           --><TextRegular :isInline="true"><!--
             -->.<!--
           --></TextRegular>
            </template>
          </div>
        </div>
        <template v-if="requestDone">
          <div
            v-if="passwordReset || signup"
            :style="style.completion"
          >
            <TextRegular :isInline="true">
              Sent {{ sentResource }} to
            </TextRegular>
            <TextEmailPrimary :isInline="true">
              {{ form.data.email }}
            </TextEmailPrimary><!-- Avoid auto-added whitespace
         --><TextRegular><!--
           -->.<!--
         --></TextRegular>
          </div>
          <div
            v-if="passwordReset || signup"
            :style="style.footer"
          >
            <ButtonWideSecondary
              v-if="signup"
              @click="requestEmailVerification"
            >
              Send again
            </ButtonWideSecondary>
            <ButtonWideSecondary
              v-else-if="passwordReset"
              @click="requestPasswordResetCode"
            >
              Send again
            </ButtonWideSecondary>
          </div>
        </template>
        <template v-else-if="isRequesting">
          <BeatLoaderPrimary :style="style.loader">
            <template
              v-if="!login"
              v-slot:footer
            >
              <TextRegular :isInline="true">
                Sending {{ sentResource }} to
              </TextRegular>
              <TextEmailPrimary :isInline="true">
                {{ form.data.email }}.
              </TextEmailPrimary>
            </template>
          </BeatLoaderPrimary>
        </template>
        <template v-else>
          <LogoImagePrimary
            v-if="!passwordReset"
            :disabled="true"
            :useWordmark="true"
            :style="getImageStyle"
          />
          <div :style="style.footer">
            <TextWarningPrimary
              v-if="errors.length > 0"
              :style="style.error"
            >
              {{ errors[0] }}
            </TextWarningPrimary>
            <FormEmailVerificationPrimary :form.sync="form" />
            <template v-if="login">
              <LinkMutedPrimary
                :to="{ name: 'password-reset' }"
                :style="style.linkPasswordReset"
              >
                Forgot password?
              </LinkMutedPrimary>
            </template>
            <template v-if="signup">
              <ButtonWidePrimary
                :disabled="disableButton"
                @click="requestEmailVerification"
                :style="getButtonStyle"
              >
                Continue
              </ButtonWidePrimary>
              <div :style="style.textAgreement">
                <TextRegular :isInline="true">
                  By clicking "Continue", you are agreeing to our
                </TextRegular>
                <LinkPrimary
                  :href="externalLinks.TERMS_OF_SERVICE"
                  :isInline="true"
                >
                  Terms of Service
                </LinkPrimary>
                <TextRegular :isInline="true">
                  and
                </TextRegular>
                <LinkPrimary
                  :href="externalLinks.PRIVACY_POLICY"
                  :isInline="true"
                >
                  Privacy Policy<!--
             --></LinkPrimary><!--
             --><TextRegular :isInline="true"><!--
               -->. California Notice at Collection can be found <!--
             --></TextRegular><!--
             --><LinkPrimary
                  :href="externalLinks.CALIFORNIA_NOTICE"
                  :isInline="true"
                ><!--
               -->here<!--
             --></LinkPrimary><!--
             --><TextRegular :isInline="true"><!--
               -->.<!--
             --></TextRegular>
              </div>
            </template>
            <template v-else-if="login">
              <ButtonWidePrimary
                :disabled="disableButton"
                @click="validateEmail"
                :style="getButtonStyle"
              >
                Continue
              </ButtonWidePrimary>
            </template>
            <template v-else>
              <ButtonWidePrimary
                :disabled="disableButton"
                @click="requestPasswordResetCode"
                :style="getButtonStyle"
              >
                Continue
              </ButtonWidePrimary>
              <div :style="style.linkBack">
                <TextRegular :isInline="true">
                  Back to
                </TextRegular>
                <LinkPrimary
                  :isInline="true"
                  :to="{ name: 'login' }"
                >
                  log in<!-- Avoid auto-added whitespace
             --></LinkPrimary><!--
             --><TextRegular :isInline="true"><!--
               -->.<!--
             --></TextRegular>
              </div>
            </template>
          </div>
        </template>
      </CardSecondary>
    </div>
  </LayoutAuthPrimary>
</template>

<script>
  import ApiEmailAvailability from '@js/api/email-availability'
  import ApiEmailVerificationCode from '@js/api/email-verification-code'
  import ApiPasswordResetCode from '@js/api/password-reset-code'
  import ApiSsoAuthorizationUrl from '@js/api/sso-authorization-url'
  import BeatLoaderPrimary from '@modules/v2/loader/beat-loader-primary'
  import ButtonWidePrimary from '@modules/v2/button/button-wide-primary'
  import ButtonWideSecondary from '@modules/v2/button/button-wide-secondary'
  import CardSecondary from '@modules/v2/card/card-secondary'
  import FormEmailVerificationPrimary
    from '@modules/v2/form/form-email-verification-primary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import HttpStatus from 'http-status-codes'
  import LayoutAuthPrimary from '@modules/v2/layout/layout-auth-primary'
  import LinkMutedPrimary from '@modules/v2/link/link-muted-primary'
  import LinkPrimary from '@modules/v2/link/link-primary'
  import LogoImagePrimary from '@modules/v2/image/logo-image-primary'
  import TextEmailPrimary from '@modules/v2/text/text-email-primary'
  import TextRegular from '@modules/v2/text/text-regular'
  import TextWarningPrimary from '@modules/v2/text/text-warning-primary'
  import { EXTERNAL_LINKS } from '@js/constants'
  import { FormEmailVerification } from '@js/forms/email-verification'
  import { getMessageLifetime } from '@js/interface-utils'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'EmailVerificationView',
    components: {
      BeatLoaderPrimary,
      ButtonWidePrimary,
      ButtonWideSecondary,
      CardSecondary,
      FormEmailVerificationPrimary,
      HeaderLargePrimary,
      LayoutAuthPrimary,
      LinkMutedPrimary,
      LinkPrimary,
      LogoImagePrimary,
      TextEmailPrimary,
      TextRegular,
      TextWarningPrimary,
    },
    data: function () {
      return {
        context: null,
        contexts: ['login', 'password-reset', 'signup',],
        emailAvailability: {},
        errors: [],
        errorTimer: null,
        externalLinks: EXTERNAL_LINKS,
        form: new FormEmailVerification(),
        headerTexts: {
          login: 'Log in',
          'password-reset': 'Reset password',
          signup: 'Let\'s create your account.',
        },
        isRequesting: false,
        requestDone: false,
        ssoAuthorizationUrl: '',
        style: {
          completion: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            margin: `${Layout.space.md} 0`,
            width: '100%',
          },
          container: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            padding: `${Layout.space.lg} 0`,
            width: '100%',
          },
          error: {
            justifyContent: 'center',
            position: 'absolute',
            textAlign: 'center',
            top: `-42px`,
            width: '100%',
          },
          footer: {
            position: 'relative',
            width: '100%',
          },
          link: {
            display: 'inline-block',
          },
          linkBack: {
            margin: `${Layout.space.lg} 0 0 0`,
            textAlign: 'center',
            width: '100%',
          },
          linkPasswordReset: {
            margin: `${Layout.space.md} 0`,
          },
          loader: {
            flex: 1,
            margin: `${Layout.space.md} 0`
          },
          subHeader: {
            margin: `${Layout.space.md} 0 0 0`,
          },
          textAgreement: {
            margin: `${Layout.space.lg} 0 0 0`,
            width: '100%',
          },
        },
      };
    },
    created: function () {
      this.context = this.$route?.params?.context;
      if (!this.contexts.includes(this.context)) {
        this.$router.push({ name: 'signup' });
      }

      if (this.login && this.authorized) {
        this.$router.push({ name: 'tenants' });
      }

      if (this.signup) {
        document.title += ' | Sign Up';
      } else if (this.login) {
        document.title += ' | Login';
      } else if (this.passwordReset) {
        document.title += ' | Password Reset';
      }
    },
    computed: {
      ...mapGetters('auth', ['refreshTokenExpired']),
      authorized: function () {
        return !this.refreshTokenExpired;
      },
      disableButton: function () {
        return this.form.errors.length > 0 || this.isRequesting;
      },
      getButtonStyle: function () {
        return {
          margin: this.login ? 'none' : `${Layout.space.lg} 0 0 0`,
        };
      },
      getCardStyle: function () {
        return {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: 'fit-content',
          justifyContent: 'space-between',
          maxWidth: '400px',
          padding: `${Layout.space.xl} ${Layout.space.lg}`,
          width: '90%',
        };
      },
      getHeaderStyle: function () {
        return {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          margin: this.passwordReset ? `0 0 ${Layout.space.xl} 0` : 'none',
          width: '100%',
        };
      },
      getImageStyle: function () {
        return {
          margin: this.signup ? '73px 0' : '102px 0',
          maxWidth: '280px',
          width: '100%',
        };
      },
      login: function () {
        return this.context === 'login';
      },
      passwordReset: function () {
        return this.context === 'password-reset';
      },
      sentResource: function () {
        if (this.signup) {
          return 'verification email';
        } else if (this.passwordReset) {
          return 'reset link';
        }
        return '';
      },
      signup: function () {
        return this.context === 'signup';
      },
    },
    methods: {
      addError: function (message) {
        if (!message) {
          return;
        }

        clearTimeout(this.errorTimer);
        this.errors = [message];
        this.errorTimer = setTimeout(() => {
          this.errors = [];
        }, getMessageLifetime(message.length, true));
      },
      clearError: function () {
        this.errors = [];
      },
      clearStatus: function () {
        this.emailAvailability = {};
        this.ssoAuthorizationUrl = '';
        this.isRequesting = false;
        this.requestDone = false;
      },
      fetchSsoAuthorizationUrl: async function () {
        const payload = await {
          email: this.form.data.email,
        };
        const api = await new ApiSsoAuthorizationUrl();
        const res = await api.post(payload);
        this.ssoAuthorizationUrl = await res.data.authorizationUrl;
      },
      fetchEmailAvailability: async function () {
        const payload = await this.form.getPostPayload();
        const api = await new ApiEmailAvailability();
        const res = await api.post(payload);
        this.emailAvailability = await res.data;
      },
      requestEmailVerification: async function () {
        this.clearStatus();
        this.isRequesting = true;

        try {
          await this.fetchEmailAvailability();
          if (!this.emailAvailability['isAvailable']) {
            const message = 'The email address is already used.';
            this.addError(message);
            throw message;
          }

          const payload = await this.form.getPostPayload();
          const api = await new ApiEmailVerificationCode();
          await api.post(payload);

          this.requestDone = await true;
        } catch (error) {
          console.error(error);
          this.clearStatus();
        } finally {
          this.isRequesting = false;
        }
      },
      requestPasswordResetCode: async function () {
        this.clearStatus();
        this.isRequesting = true;

        try {
          await this.fetchSsoAuthorizationUrl();
          if (this.ssoAuthorizationUrl) {
            const message = (
              'The email domain is linked to Single Sign-On. ' +
              'Password reset is not allowed.'
            );
            this.addError(message);
            throw message;
          }

          await this.fetchEmailAvailability();
          if (this.emailAvailability['isAvailable']) {
            const message = 'Email not registered. Please sign up.';
            this.addError(message);
            throw message;
          }

          const payload = await this.form.getPostPayload();
          const api = await new ApiPasswordResetCode();
          const res = await api.post(payload);

          this.requestDone = await true;
        } catch (error) {
          console.error(error);
          this.clearStatus();
        } finally {
          this.isRequesting = false;
        }
      },
      validateEmail: async function () {
        this.clearStatus();
        this.isRequesting = true;

        try {
          await this.fetchEmailAvailability();
          if (this.emailAvailability['isAvailable']) {
            const message = 'Email not registered. Please sign up.';
            this.addError(message);
            throw message;
          }

          const query = await {
            email: encodeURIComponent(this.form.data.email),
          };
          await this.$router.push({ name: 'login-continue', query: query });
        } catch (error) {
          console.error(error);
          this.clearStatus();
        } finally {
          this.isRequesting = false;
        }
      },
    },
  };
</script>
